var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgErrorButtonIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1665 8.66667C15.1665 6.08934 13.0772 4 10.4998 4H3.83317C3.46498 4 3.1665 4.29848 3.1665 4.66667C3.1665 5.03486 3.46498 5.33333 3.83317 5.33333H10.4998C12.3408 5.33333 13.8332 6.82572 13.8332 8.66667C13.8332 10.5076 12.3408 12 10.4998 12C8.65889 12 7.1665 10.5076 7.1665 8.66667C7.1665 8.29848 6.86803 8 6.49984 8C6.13165 8 5.83317 8.29848 5.83317 8.66667C5.83317 11.244 7.92251 13.3333 10.4998 13.3333C13.0772 13.3333 15.1665 11.244 15.1665 8.66667Z",
    fill: "#009866"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.02876 4.1951C1.76841 4.45545 1.76841 4.87756 2.02876 5.13791L3.36209 6.47124C3.62244 6.73159 4.04455 6.73159 4.3049 6.47124C4.56525 6.21089 4.56525 5.78878 4.3049 5.52843L3.44297 4.6665L4.3049 3.80458C4.56525 3.54423 4.56525 3.12212 4.3049 2.86177C4.04455 2.60142 3.62244 2.60142 3.36209 2.86177L2.02876 4.1951Z",
    fill: "#1C3D45"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorButtonIcon);
export default __webpack_public_path__ + "static/media/error_button_icon.4d2098559959596ab899863d5aa9e405.svg";
export { ForwardRef as ReactComponent };